import React from "react";
import Buttons from "2g-buttons";
import { Icons } from "2g-icons";

export default function (handleClick) {
  return {
    id: "declineAction",
    isAction: true,
    onClick: handleClick,
    path: "",
    renderer: () => (
      <Buttons.Danger inverse rounded>
        <Icons.CloseLight />
      </Buttons.Danger>
    )
  };
}
